'use strict';

function CnDistributionBoxController() {
  var vm = this;

  vm.$onInit = $onInit;

  vm.managerHasPoints = managerHasPoints;
  vm.employeeHasPoints = employeeHasPoints;
  vm.performanceHasPoints = performanceHasPoints;

  // 3 because there are 3 points per each question
  var MAX_POINTS_PER_QUESTION = 3;

  function $onInit() {
    vm.managerPoints = vm.managerPoints || 0;
    vm.employeePoints = vm.employeePoints || 0;
    vm.performancePoints = vm.performancePoints || 0;
    vm.calculatePosition = calculatePosition(vm.maxPoints || 0);
  }

  function managerHasPoints() {
    return vm.managerPoints > 0;
  }

  function performanceHasPoints() {
    return vm.performancePoints > 0;
  }

  function employeeHasPoints() {
    return vm.managerHasPoints() && vm.employeePoints > 0;
  }

  function calculatePosition(max) {
    return function usingPoints(value) {
      if(max === 0) {
        return 50;
      }
      var min = max / MAX_POINTS_PER_QUESTION;
      if (value > max) {
        value = max;
      }
      if (value < min) {
        value = min;
      }
      return Math.floor(((value - min) / (max - min)) * 100);
    };
  }
}

module.exports = CnDistributionBoxController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-distribution-box/cn-distribution-box.controller.js
 ** module id = 60
 ** module chunks = 0
 **/